export default __webpack_public_path__ + "static/media/TopStars.b0fb33f8.svg";